export function getStringBucketName(bucket: string[]): string {
  return bucket.join(', ');
}
